// extracted by mini-css-extract-plugin
export var black = "_w-6";
export var brand = "_w-1";
export var ddefault = "_w-0";
export var error = "_w-3";
export var gray = "_w-2";
export var highContrast = "_w-8";
export var outline = "_w-7";
export var success = "_w-5";
export var warning = "_w-4";